export const SECOND = 1000;
export const SECONDS = SECOND;

export const MINUTE = 60 * SECONDS;
export const MINUTES = MINUTE;

export const HOUR = 60 * MINUTES;
export const HOURS = HOUR;
